var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.query.payType === 'salaried')?_c('SalariedPayrun'):_vm._e(),(_vm.$route.query.payType === 'hourly')?_c('HourlyPayrun',{directives:[{name:"feature-request",rawName:"v-feature-request"}]}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }